import { Box, Button } from '@chakra-ui/react';
import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCreateFundingRequestMutation } from '~/borrower/domains/fundingRequests/requests/fundingRequests.gql.generated';
import { LoadingView } from '~/borrower/domains/fundingRequests/ui/shared/Loading';
import { GetEventsDocumentGQLType } from '~/core/routes/events/legacy/events.gql.generated';
import { Icon } from '~/packages/common-frontend/components/icons';
import { PageHeader } from '~/packages/common-frontend/components/PageContainer';
import {
  useCanFundingRequestBeCreatedQuery,
  GetFundingRequestsWithBaseDetailsDocumentGQLType,
} from '~/packages/funding-requests/requests/requests.gql.generated';
import CanFundingRequestBeCreatedAlertMessage from '~/packages/funding-requests/ui/CanFundingRequestBeCreatedAlertMessage';

export const FundingRequestLandingDefault = ({
  creditFacilityId,
}: {
  creditFacilityId: string;
}) => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // TODO: need to fetch all credit-facility-id here...
  // NOTE: currently supports one and only one facility
  const [createFundingRequestMutate] = useCreateFundingRequestMutation({
    refetchQueries: [
      {
        query: GetFundingRequestsWithBaseDetailsDocumentGQLType,
        variables: { creditFacilityIds: [creditFacilityId] },
      },
      GetEventsDocumentGQLType,
    ],
  });

  // Initiate funding request creation and redirect to plan page upon success
  const initiateFundingRequest = useCallback(async () => {
    setIsSubmitting(true);
    // TODO: need to fetch this from query result
    const { data: newFundingRequestData } = await createFundingRequestMutate({
      variables: {
        creditFacilityId,
      },
    });

    if (newFundingRequestData) {
      const { createFundingRequest } = newFundingRequestData;
      const { fundingRequestId } = createFundingRequest;
      const redirectUrl = `/funding-requests/${fundingRequestId}`;
      setIsSubmitting(false);
      navigate(redirectUrl);
    }
  }, [createFundingRequestMutate, creditFacilityId, navigate]);

  const {
    loading,
    data: canFundingRequestBeCreatedData,
  } = useCanFundingRequestBeCreatedQuery({
    variables: {
      creditFacilityId,
    },
    fetchPolicy: 'network-only',
  });
  if (loading || !canFundingRequestBeCreatedData) {
    return <LoadingView />;
  }
  const {
    canCreate,
    errorCode,
  } = canFundingRequestBeCreatedData.canFundingRequestBeCreated;

  return (
    <Box>
      <Box>
        <PageHeader
          headerLabel="Initiate new funding request"
          subheaderLabel="When you initiate a new funding request, Finley will automatically
          calculate an optimized funding request package for your review and
          approval."
        />
        {errorCode ? (
          <CanFundingRequestBeCreatedAlertMessage errorCode={errorCode} />
        ) : (
          <Button
            variant="secondary"
            colorScheme="gray"
            width="fit-content"
            isLoading={isSubmitting}
            rightIcon={<Icon icon="arrow-right" />}
            onClick={initiateFundingRequest}
            isDisabled={!canCreate}
          >
            Initiate
          </Button>
        )}
      </Box>
    </Box>
  );
};
